import React, { useEffect } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ShipmentCloneStep1 from "./step1";
import ShipmentCloneStep2 from "./step2";
import ShipmentCloneStep3 from "./step3";
import { IsRequiredValidation } from "./formValidation";
import {updateUI, fetchDeviceRequest,fetchRequest,fetchProfileRequest,fetchAlertRequest,createRequest,updateshipRequest,fetchDeviceNameRequest } from "../../../store/actions/shipment";

function EditShipment() {
  const dispatch = useDispatch();
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const { isEditShipmentOpen, step, isSaved,editField,editRecord,editShipment } = useSelector((state) => ({
    isEditShipmentOpen:state.shipment.ui.editShipment.isEditShipment,
    step: state.shipment.ui.editShipment.step,
    isSaved: state.shipment.ui.editShipment.isSaved,
    editField: state.shipment.ui.editShipment.editField,
    editRecord:state.shipment.ui.editShipment.editRecord,
    editShipment:state.shipment.ui.editShipment
  }));

  useEffect(() => {
    if (isEditShipmentOpen) {
      dispatch(fetchDeviceRequest());
      dispatch(fetchProfileRequest());
      dispatch(fetchAlertRequest());
      dispatch(fetchDeviceNameRequest());
      dispatch(fetchRequest());
    }
  }, [isEditShipmentOpen,dispatch])
  const transformedBleDevices = Array.isArray(editRecord?.record?.bledevice)
    ? editRecord.record.bledevice
      .map(device => ({
        uid: device.id,
        name: device.name,
        deviceProfile: device.profile,
        serial: device.serial
      }))
    : [];
  const LastdeviceProfile = transformedBleDevices.length > 0
    ? transformedBleDevices[transformedBleDevices.length - 1].deviceProfile
    : null;
  function getDeviceDetails(devices, deviceProfile) {
    let result = devices?.find(device => device?.profilename === deviceProfile);
    if (result) {
      return {
        attributes: result?.attributes,
            name:result?.name
      };
    }
  }
  var extractedDetails = getDeviceDetails(shipmetProfile, LastdeviceProfile);
  useEffect(() => {
    if (!editRecord?.record) return;
    const fieldMapping = {
      shipmentName: ["shipmentName", "shipmentname"],
      devicetype: ["devicetype"],
      profile: ["customername"],
      isBLEEnabled: ["enableble"],
      onShipmentCompletion: ["oncompletion"],
      productSerialNumber: ["productserialnumber"],
      trackingNumber: ["trackingnumber"],
      orderNumber: ["ordernumber"],
      customerName: ["customername"],
      poNumber: ["ponumber"],
      state: ["state", "shipmentstate"],
      productId: ["productid"],
      selectProfile: ["deviceprofile"],
      shipmentid: ["shipmentid"],
      deviceId: ["deviceid"],
      devicename: ["devicename"],
      startDate: ["startDate", "startdate"],
    };
    const normalizedRecord = Object.keys(editRecord.record).reduce((acc, key) => {
      acc[key.toLowerCase()] = editRecord.record[key];
      return acc;
    }, {});
    const updatedEditField = Object.keys(fieldMapping).reduce((acc, key) => {
      const possibleKeys = fieldMapping[key].map(k => k.toLowerCase()); // Normalize possible keys
      const foundKey = possibleKeys.find(k => normalizedRecord.hasOwnProperty(k)); // Find first matching key
      acc[key] = {
        ...editField[key],
        value: key === "shipmentName" && editRecord?.record?.editorClone === "clone"
          ? ""
          : foundKey ? normalizedRecord[foundKey] : undefined // Use the first matching key
      };
      return acc;
    }, { ...editField });
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          editField: updatedEditField,
          selectedProfileId: editRecord.record.deviceprofile?.id,
          ble: transformedBleDevices,
          bleProfile: extractedDetails?.attributes,
        },
      })
    );
  }, [editRecord]);

  const handleOk = () => {
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          isEditShipment: false,
        },
      })
    );
  };

  const handleAdd = () => {
    const response= dispatch(editRecord?.record?.editorClone === "clone" ?createRequest([editShipment]): updateshipRequest({ ...editShipment }));
    if (response?.payload?.editField?.shipmentid?.value) {
      dispatch(
        updateUI({
          key: "editShipment",
          value: {
            isEditShipment: false,
            step: 1,
          },
        })
      );
      dispatch(fetchRequest());
    }
  };
  const isNextButtonDisabled = () =>
    !editShipment.ble.every(item => item.deviceProfile !== "") &&
    step === 1 &&
    editField.isBLEEnabled?.value === "yes";
  const handleNext = () => {
    const fieldsToValidate = ["shipmentName", "startDate", "devicetype", "deviceId"];
  
    let isFormValid = true;
    let updatedFields = { ...editField };
  
    fieldsToValidate.forEach((field) => {
      const validator = IsRequiredValidation(editField[field]?.value || "");
      updatedFields[field] = { ...validator, value: editField[field]?.value };
  
      if (!validator.isValid) {
        isFormValid = false;
      }
    });
  
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          editField: updatedFields,
        },
      })
    );
  
    if (isFormValid) {
      dispatch(
        updateUI({
          key: "editShipment",
          value: {
            step: 3,
          },
        })
      );
    }
  };
  

  const handleSave = () => {
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          step: 1,
        },
      })
    );
  };

  const handleCancel = () => {
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          isEditShipment: false,
          step: 1,
        },
      })
    );
  };

  const handleBackAndCancelButton = () => {
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          selectedProfile: {},
          step: 1,
        },
      })
    );
  };

  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 shipment-clone"
      title=""
      open={isEditShipmentOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={{
        xs: "90%",
        sm: "80%",
        md: "90%",
        lg: "88%",
        xl: "85%",
        xxl: "80%",
      }}
      footer={() => {
        if (step === 2) {
          return [
            <button
              key="back"
              className="cancel"
              onClick={handleBackAndCancelButton}
            >
              Cancel
            </button>,
            <button
              key="submit"
              disabled={!editShipment?.selectedProfileId}
              className="update"
              onClick={handleSave}
            >
              Save
            </button>,
          ];
        }
        if (step === 3) {
          return [
            <button
              key="back"
              className="cancel"
              onClick={handleBackAndCancelButton}
            >
              Cancel
            </button>,
            <button
              key="submit"
            //  disabled={!isSaved}
              className="update"
              onClick={handleAdd}
            >
              Save
            </button>,
          ];
        }
        return [
          <button key="back" className="cancel" onClick={handleCancel}>
            Cancel
          </button>,
          <button disabled={isNextButtonDisabled()} key="submit" className="update" onClick={handleNext}>
            Next
          </button>,
        ];
      }}
    >
      {/* --- Fixed Header Section --- */}
      <div>
        {step !== 1 && (
          <button
            onClick={handleBackAndCancelButton}
            className="shipping-clone-back-button"
          >
            <ArrowLeftOutlined />
          </button>
        )}
        <div className="py-2">
          <div
            className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "30px",
          }}
          >
            {editRecord?.record?.editorClone === "clone" ? "Clone Shipment" : "Edit Shipment"}
          </div>
        </div>
      </div>

      {/* --- Scrollable Content Section --- */}
      <div className="scrollable-content-hidden-scrollbar">
        {step === 1 && <ShipmentCloneStep1 />}
        {step === 2 && <ShipmentCloneStep2 />}
        {step === 3 && <ShipmentCloneStep3 />}
      </div>
    </Modal>
  );
}

export default EditShipment;